import { useStore as o } from "../use-store.js";
import { useIsoMorphicEffect as n } from "../use-iso-morphic-effect.js";
import { overflows as a$1 } from "./overflow-store.js";
function a(r, e, n$1 = () => ({ containers: [] })) {
  let f = o(a$1), o$1 = e ? f.get(e) : void 0, i = o$1 ? o$1.count > 0 : false;
  return n(() => {
    if (!(!e || !r)) return a$1.dispatch("PUSH", e, n$1), () => a$1.dispatch("POP", e, n$1);
  }, [r, e]), i;
}
export {
  a as useDocumentOverflowLockedEffect
};
